import { render, staticRenderFns } from "./remoteTooltip.vue?vue&type=template&id=4fa47e51"
import script from "./remoteTooltip.vue?vue&type=script&lang=js"
export * from "./remoteTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports